module.exports = __webpack_public_path__ + "static/img/item2-pick.13171c90.png";